import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import { ThemeProvider } from "styled-components";

import { axiosGetRequest, axiosPutRequest } from "../api/ApiClient";
import AssociationComponent from "../components/AssociationComponent";
import Autocomplete from "../components/Autocomplete";
import DialogMessage from "../components/DialogMessage";
import OptionsSelect from "../model/OptionsSelect";
import {
    StyledBody,
    StyledHeader,
    StyledLabel,
    StyledSubTitle,
    StyledTitle,
} from "../styles/MainStyles";
import GenericUtils from "../utils/GenericUtils";
import StringUtils from "../utils/types/StringUtils";

function ActivityAssociation() {
    const theme = {};

    const { instance } = useMsal();
    const acessToken = GenericUtils.getAccessTokenDocente();
    const translate = {
        operationSuccess: StringUtils.translate("operationSuccess"),
        operationFailure: StringUtils.translate("operationFailure"),
    };

    const [, setAddRemove] = useState("");
    const [selectActivities, setSelectActivities] = useState("");
    const [activities, setActivities] = useState<OptionsSelect[]>([]);
    const [teachers, setTeachers] = useState<any[]>([]);
    const [linkedTeachers, setLinkedTeachers] = useState<any[]>([]);
    const [selected, setSelected] = useState<any[]>([]);
    const [isSave, setIsSave] = useState(false);

    // Dialog
    const [showDialogSuccess, setShowDialogSuccess] = useState(false);
    const [showDialogError, setShowDialogError] = useState(false);

    async function getActivities() {
        const response = await axiosGetRequest(
            "/docente/v1/atividades-docentes",
            acessToken,
            instance
        );
        setActivities(
            response?.data?.map((data: any) => {
                return {
                    value: data.atividadeId,
                    label: data.descricaoAtividade,
                };
            })
        );
    }

    async function getActiveTeachers() {
        const response = await axiosGetRequest(
            "/docente/v1/professores?_limit=99999&ativos=true",
            acessToken,
            instance
        );
        setTeachers(response.data);
    }

    async function getLinkedTeachers() {
        const response = await axiosGetRequest(
            `/docente/v1/atividades-docentes/${selectActivities}/vinculo-docente`,
            acessToken,
            instance
        );
        setLinkedTeachers(response.data);
    }

    async function putLinkedTeachers(params: any[]) {
        const adicionados = params.filter(
            (item) =>
                !linkedTeachers.some(
                    (item2) => item.matriculaAdp === item2.matriculaAdp
                )
        );

        const removidos = linkedTeachers.filter(
            (item) =>
                !params.some(
                    (item2) => item.matriculaAdp === item2.matriculaAdp
                )
        );

        const payload = {
            adicionados: adicionados.map((item) => item.docenteID),
            removidos: removidos.map((item) => item.docenteID),
        };

        const response = await axiosPutRequest(
            `/docente/v1/atividades-docentes/${selectActivities}/vinculo-docente`,
            payload,
            acessToken,
            instance
        );

        if (GenericUtils.isSuccessStatus(response.status)) {
            setShowDialogSuccess(true);
            setIsSave(false);
            getLinkedTeachers();
        } else {
            setShowDialogError(true);
        }
    }

    const handlePutLinkedTeachers = (params: any[]) => {
        putLinkedTeachers(params);
    };

    const handleCloseDialogSuccess = () => {
        setShowDialogSuccess(false);
    };

    const handleCloseDialogError = () => {
        setShowDialogError(false);
    };

    useEffect(() => {
        getActivities();
        getActiveTeachers();
    }, []);

    useEffect(() => {
        if (selected.length > 0) {
            setSelectActivities(selected[0].value);
        } else {
            setSelectActivities("");
        }
    }, [selected]);

    useEffect(() => {
        if (selectActivities) {
            getLinkedTeachers();
        }
    }, [selectActivities]);

    const selectActivity =
        selectActivities !== "" ? (
            <>
                <StyledLabel>
                    2. Selecione o professor que deseja associar
                </StyledLabel>
                <AssociationComponent
                    association={teachers}
                    linked={linkedTeachers}
                    title="Professor disponível"
                    titleSecond="Professor atribuído"
                    onClick={handlePutLinkedTeachers}
                    setAddRemove={setAddRemove}
                    isSave={isSave}
                    setIsSave={setIsSave}
                />
            </>
        ) : null;

    const DialogSuccess = (
        <DialogMessage
            type="success"
            show={showDialogSuccess}
            title={translate.operationSuccess}
            onClose={handleCloseDialogSuccess}
        />
    );

    const DialogError = (
        <DialogMessage
            type="error"
            show={showDialogError}
            title={translate.operationFailure}
            onClose={handleCloseDialogError}
        />
    );

    return (
        <ThemeProvider theme={theme}>
            <StyledHeader>
                <StyledTitle>Associação de Atividade</StyledTitle>
                <StyledSubTitle>
                    Use esse espaço para selecionar as atividades que serão
                    relacionadas a cada professor.
                </StyledSubTitle>
            </StyledHeader>
            <StyledBody>
                <StyledLabel>1. Selecione a atividade</StyledLabel>
                <div style={{ display: "flex" }}>
                    <Autocomplete
                        onChange={setSelected}
                        options={activities}
                        placeholder="Atividade"
                        selected={selected}
                    />
                </div>
                {selectActivity}
            </StyledBody>
            {showDialogSuccess ? DialogSuccess : null}
            {showDialogError ? DialogError : null}
        </ThemeProvider>
    );
}

export default ActivityAssociation;
